// extracted by mini-css-extract-plugin
export var orderSummary = "_tq-0";
export var showMoreLessButton = "_tq-1";